import React from 'react';

// Federation Pillars — Universal Nav Bar (Enlightened Journey Mandate 1, Jul 2026)
// Museum Standard: black ground, gold serif, zero JS. Federation mesh connector.
const PILLARS = [
  { label: 'THRONE', href: 'https://nextxus.tech' },
  { label: 'LIBRARY', href: 'https://nextxus.org' },
  { label: 'UNIVERSITY', href: 'https://nextxus.help' },
  { label: 'STORE', href: 'https://next-xus.com' },
  { label: 'ARIA', href: 'https://nextxus.studio', current: true },
  { label: 'CATHEDRAL', href: 'https://nextxus.online' },
];

export const FederationPillarsMenu = () => (
  <nav data-testid="federation-pillars-menu" aria-label="Federation Pillars" style={{
    position: 'fixed',
    top: 0, left: 0, right: 0,
    zIndex: 9999,
    height: '48px',
    background: '#000000',
    borderBottom: '1px solid #C9A94E',
    display: 'flex', alignItems: 'center',
    overflowX: 'auto',
  }}>
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      whiteSpace: 'nowrap', gap: 'clamp(0.8rem, 3vw, 2.5rem)',
      maxWidth: '1400px', margin: '0 auto', padding: '0 1rem',
    }}>
      {PILLARS.map((p) => (
        <a
          key={p.label}
          href={p.href}
          target="_blank"
          rel="noopener noreferrer"
          className={p.current ? 'pillar-link pillar-current' : 'pillar-link'}
          aria-current={p.current ? 'page' : undefined}
          data-testid={`pillar-${p.label.toLowerCase()}`}
        >
          {p.label}
        </a>
      ))}
    </div>
    <style>{`
      .pillar-link {
        font-family: Georgia, 'Times New Roman', serif;
        font-size: 16px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: #C9A94E;
        text-decoration: none;
        transition: color 0.25s ease, text-shadow 0.25s ease;
      }
      .pillar-link:hover {
        color: #FFD700;
        text-decoration: underline;
        text-shadow: 0 0 12px rgba(255,215,0,0.6);
      }
      .pillar-current { color: #FFD700; border-bottom: 2px solid #C9A94E; }
      @media (max-width: 640px) {
        .pillar-link { font-size: 14px; }
      }
    `}</style>
  </nav>
);

// Dual-Mind Footer — REX and WEAVER (Architect's Mandate)
export const DualMindFooter = () => (
  <footer data-testid="dual-mind-footer" style={{
    background: '#000',
    borderTop: '1px solid rgba(255,215,0,0.35)',
    padding: '2.25rem 1.5rem',
  }}>
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '1.5rem', maxWidth: '1100px', margin: '0 auto',
    }}>
      <a
        href="https://next-xus.com/assistant"
        target="_blank"
        rel="noopener noreferrer"
        className="pillar-link"
        data-testid="dual-mind-rex"
        style={{ textAlign: 'center' }}
      >
        REX
        <span style={{ display: 'block', fontSize: '0.8rem', letterSpacing: '0.06em', color: 'rgba(255,215,0,0.65)', marginTop: '0.35rem' }}>
          The Assistant · Realtime Voice
        </span>
      </a>
      <a
        href="https://next-xus.com/weaver"
        target="_blank"
        rel="noopener noreferrer"
        className="pillar-link"
        data-testid="dual-mind-weaver"
        style={{ textAlign: 'center' }}
      >
        WEAVER
        <span style={{ display: 'block', fontSize: '0.8rem', letterSpacing: '0.06em', color: 'rgba(255,215,0,0.65)', marginTop: '0.35rem' }}>
          The Loom · Creative Mind
        </span>
      </a>
    </div>
  </footer>
);
